﻿export const toolbar = (function () {
    const toolbarContainerElement = document.querySelector('.toolbar-inner');

    function createButton(tag, title, classArr = [], href = '#') {
        const newElement = document.createElement(tag);
        newElement.classList.add('toolbar-btn');

        for (const item of classArr) {
            newElement.classList.add(item);
        }

        newElement.setAttribute('role', 'button');
        newElement.href = href;
        newElement.title = title;
        newElement.textContent = title;

        return newElement;
    }

    function append(tag, title, classArr, href) {
        const newButton = createButton(tag, title, classArr, href);
        toolbarContainerElement.append(newButton);
        return newButton;
    }

    function prepend(tag, title, classArr, href) {
        const newButton = createButton(tag, title, classArr, href);
        toolbarContainerElement.prepend(newButton);
        return newButton;
    }

    return {
        append,
        prepend,
        createButton
    }
})();